import { render, staticRenderFns } from "./CommentBody.vue?vue&type=template&id=2c0dd35c&scoped=true"
import script from "./CommentBody.vue?vue&type=script&lang=js"
export * from "./CommentBody.vue?vue&type=script&lang=js"
import style0 from "./CommentBody.vue?vue&type=style&index=0&id=2c0dd35c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0dd35c",
  null
  
)

export default component.exports